/* @flow weak */

import * as React from 'react';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import TitleHeader from 'components/TitleHeader';

import './styles/PhoneCallRetryView.scss';

type Props = {
  name: string,
  onRetry: () => void,
  onCancel: () => void,
};

function PhoneCallRetryView(props: Props) {
  const name = props.name || '';

  const buttons = (
    <Buttons>
      <Button level="primary" data-test="retry-button" onClick={props.onRetry}>
        Retry
      </Button>
      <Button level="secondary" data-test="cancel-button" onClick={props.onCancel}>
        Cancel
      </Button>
    </Buttons>
  );

  return (
    <div className="PhoneCallRetryView">
      <TitleHeader
        action={buttons}
        subtext={`You’ll need to answer your phone to reach ${name}.`}
        title="We couldn’t reach you"
        flush
      />
    </div>
  );
}
export default PhoneCallRetryView;
